import { Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import { exemptionStatus, settledExemptionStatus, noActionExemptionStatus, exemptionPageTitle } from "../../services/exemptions";
import nextActionMatrix, { possibleWizardSteps, stepToUrl } from "../../services/nextActionMatrix";

/**
 * Logic for ther buttons to start/resume an application
 * It uses a matrix of current status and request type and on which screen u r
 * to decide next step
 */
export default function MoveToNextStepButton({ exemptionType, allCurrentRequests }) {
    //first check if user even needs to get an exemption
    const noActionNeeded = allCurrentRequests.filter(anActiveRequest => {
        return noActionExemptionStatus[anActiveRequest.ohrequest_status] && anActiveRequest.ohrequest_type === exemptionType;
    });
    if (noActionNeeded.length > 0) {
        return <Alert variant="warning">{noActionExemptionStatus[noActionNeeded[0].ohrequest_status].statusDesc}</Alert>;
    }

    //Check if this is a request I can do an action on
    const activeRequests = allCurrentRequests.filter(anActiveRequest => {
        return !settledExemptionStatus[anActiveRequest.ohrequest_status] && anActiveRequest.ohrequest_type === exemptionType;
    });

    //looks like a new request
    if (activeRequests.length === 0) {
        const stepurl = stepToUrl[nextActionMatrix(exemptionStatus.non.key, exemptionType, possibleWizardSteps.dashboard)];
        return (
            // <Link className="btn btn-primary  pull-right" to={`/${stepurl}/${exemptionType}/new`}>Create {exemptionPageTitle[exemptionType]}</Link>
            <Link className="btn btn-primary my-4 float-end" to={`/${stepurl}/${exemptionType}/new`}>Create Exemption Request</Link>
        );
    }

    const stepurl = stepToUrl[nextActionMatrix(activeRequests[0].ohrequest_status, exemptionType, possibleWizardSteps.dashboard)];
    return (
        <Link className="btn btn-primary my-4 float-end" to={`/${stepurl}/${exemptionType}/${activeRequests[0].ohrequest_id}`}>
            Review/Continue your {exemptionPageTitle[exemptionType]}
        </Link>
    );
}
